import {
  createPoolDefinition as publicCreatePoolDefinition,
  bulkCreatePoolDefinitions as publicBulkCreatePoolDefinitions,
  updatePoolDefinition as publicUpdatePoolDefinition,
  bulkUpdatePoolDefinitions as publicBulkUpdatePoolDefinitions,
  deletePoolDefinition as publicDeletePoolDefinition,
  bulkDeletePoolDefinitions as publicBulkDeletePoolDefinitions,
  getPoolDefinition as publicGetPoolDefinition,
  queryPoolDefinitions as publicQueryPoolDefinitions,
  typedQueryPoolDefinitions as publicTypedQueryPoolDefinitions,
  addPoolDefinitionToProgramDefinition as publicAddPoolDefinitionToProgramDefinition,
  removePoolDefinitionFromProgramDefinition as publicRemovePoolDefinitionFromProgramDefinition,
  findPoolDefinitionsByProgramDefinition as publicFindPoolDefinitionsByProgramDefinition,
} from './benefit-programs-v1-pool-definition-pool-definitions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  PoolDefinitionQuery,
  PoolDefinitionsQueryBuilder,
  QueryPoolDefinitionsOptions,
  typedQueryPoolDefinitions as universalTypedQueryPoolDefinitions,
} from './benefit-programs-v1-pool-definition-pool-definitions.universal.js';

function customQueryPoolDefinitions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryPoolDefinitionsOptions) =>
      publicQueryPoolDefinitions(httpClient)(options),
    typedQueryFunction: (
      query: PoolDefinitionQuery,
      options?: QueryPoolDefinitionsOptions
    ) => publicTypedQueryPoolDefinitions(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: PoolDefinitionQuery,
    options?: QueryPoolDefinitionsOptions
  ): ReturnType<typeof universalTypedQueryPoolDefinitions>;
  function overloadedQuery(
    options?: QueryPoolDefinitionsOptions
  ): PoolDefinitionsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: PoolDefinitionQuery | QueryPoolDefinitionsOptions,
    options?: QueryPoolDefinitionsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createPoolDefinition: MaybeContext<
  BuildRESTFunction<typeof publicCreatePoolDefinition> &
    typeof publicCreatePoolDefinition
> = /*#__PURE__*/ createRESTModule(publicCreatePoolDefinition);
export const bulkCreatePoolDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreatePoolDefinitions> &
    typeof publicBulkCreatePoolDefinitions
> = /*#__PURE__*/ createRESTModule(publicBulkCreatePoolDefinitions);
export const updatePoolDefinition: MaybeContext<
  BuildRESTFunction<typeof publicUpdatePoolDefinition> &
    typeof publicUpdatePoolDefinition
> = /*#__PURE__*/ createRESTModule(publicUpdatePoolDefinition);
export const bulkUpdatePoolDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdatePoolDefinitions> &
    typeof publicBulkUpdatePoolDefinitions
> = /*#__PURE__*/ createRESTModule(publicBulkUpdatePoolDefinitions);
export const deletePoolDefinition: MaybeContext<
  BuildRESTFunction<typeof publicDeletePoolDefinition> &
    typeof publicDeletePoolDefinition
> = /*#__PURE__*/ createRESTModule(publicDeletePoolDefinition);
export const bulkDeletePoolDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeletePoolDefinitions> &
    typeof publicBulkDeletePoolDefinitions
> = /*#__PURE__*/ createRESTModule(publicBulkDeletePoolDefinitions);
export const getPoolDefinition: MaybeContext<
  BuildRESTFunction<typeof publicGetPoolDefinition> &
    typeof publicGetPoolDefinition
> = /*#__PURE__*/ createRESTModule(publicGetPoolDefinition);
export const addPoolDefinitionToProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicAddPoolDefinitionToProgramDefinition> &
    typeof publicAddPoolDefinitionToProgramDefinition
> = /*#__PURE__*/ createRESTModule(publicAddPoolDefinitionToProgramDefinition);
export const removePoolDefinitionFromProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicRemovePoolDefinitionFromProgramDefinition> &
    typeof publicRemovePoolDefinitionFromProgramDefinition
> = /*#__PURE__*/ createRESTModule(
  publicRemovePoolDefinitionFromProgramDefinition
);
export const findPoolDefinitionsByProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicFindPoolDefinitionsByProgramDefinition> &
    typeof publicFindPoolDefinitionsByProgramDefinition
> = /*#__PURE__*/ createRESTModule(
  publicFindPoolDefinitionsByProgramDefinition
);
export const queryPoolDefinitions: MaybeContext<
  BuildRESTFunction<typeof customQueryPoolDefinitions> &
    typeof customQueryPoolDefinitions
> = /*#__PURE__*/ createRESTModule(customQueryPoolDefinitions);

export {
  PolicyExpressionType,
  Type,
  WeekDay,
  TimePeriod,
  Cascade,
  SortOrder,
  WebhookIdentityType,
} from './benefit-programs-v1-pool-definition-pool-definitions.universal.js';
export {
  PoolDefinition,
  Details,
  Benefit,
  PolicyExpression,
  PolicyExpressionExpressionOneOf,
  PolicyExpressionNot,
  PolicyExpressionAnd,
  PolicyExpressionOr,
  Policy,
  PolicyPolicyOneOf,
  FixedIntervalPolicy,
  RateLimitedPolicy,
  CustomPolicy,
  CreditConfiguration,
  RolloverConfiguration,
  ExtendedFields,
  ProgramDefinitionInfo,
  PoolDefinitionAddedToProgramDefinition,
  PoolDefinitionRemovedFromProgramDefinition,
  PoolDefinitionUpdatedProxySupport,
  PoolDefinitionDeletedProxySupport,
  PoolDefinitionTranslated,
  PoolDefinitionTranslationDeleted,
  CreatePoolDefinitionRequest,
  CreatePoolDefinitionResponse,
  BulkCreatePoolDefinitionsRequest,
  BulkCreatePoolDefinitionsResponse,
  BulkPoolDefinitionResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  UpdatePoolDefinitionRequest,
  UpdatePoolDefinitionResponse,
  BulkUpdatePoolDefinitionsRequest,
  MaskedPoolDefinition,
  BulkUpdatePoolDefinitionsResponse,
  DeletePoolDefinitionRequest,
  DeletePoolDefinitionResponse,
  BulkDeletePoolDefinitionsRequest,
  BulkDeletePoolDefinitionsResponse,
  GetPoolDefinitionRequest,
  GetPoolDefinitionResponse,
  QueryPoolDefinitionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryPoolDefinitionsResponse,
  CursorPagingMetadata,
  Cursors,
  AddPoolDefinitionToProgramDefinitionRequest,
  AddPoolDefinitionToProgramDefinitionResponse,
  RemovePoolDefinitionFromProgramDefinitionRequest,
  RemovePoolDefinitionFromProgramDefinitionResponse,
  FindPoolDefinitionsByProgramDefinitionRequest,
  FindPoolDefinitionsByProgramDefinitionResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreatePoolDefinitionOptions,
  BulkCreatePoolDefinitionsOptions,
  UpdatePoolDefinition,
  UpdatePoolDefinitionOptions,
  BulkUpdatePoolDefinitionsOptions,
  BulkDeletePoolDefinitionsOptions,
  QueryPoolDefinitionsOptions,
  PoolDefinitionsQueryResult,
  PoolDefinitionsQueryBuilder,
  PoolDefinitionQuerySpec,
  AddPoolDefinitionToProgramDefinitionOptions,
  RemovePoolDefinitionFromProgramDefinitionOptions,
  FindPoolDefinitionsByProgramDefinitionOptions,
} from './benefit-programs-v1-pool-definition-pool-definitions.universal.js';
export { utils } from './benefit-programs-v1-pool-definition-pool-definitions.universal.js';
export {
  PolicyExpressionTypeWithLiterals,
  TypeWithLiterals,
  WeekDayWithLiterals,
  TimePeriodWithLiterals,
  CascadeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdatePoolDefinitionValidationErrors,
  BulkUpdatePoolDefinitionsValidationErrors,
  AddPoolDefinitionToProgramDefinitionValidationErrors,
  RemovePoolDefinitionFromProgramDefinitionValidationErrors,
  CommonQueryWithEntityContext,
  PoolDefinitionQuery,
} from './benefit-programs-v1-pool-definition-pool-definitions.universal.js';
